export const FI: Record<string, string> = {
  Home: "Koti",
  "Resource Selected": "Valittu resurssi",
  "Resources List": "Resurssilista",
  List: "Lista",
  Resources: "Resurssit",
  "Find Colleague": "Etsi kollega",
  Settings: "Asetukset",
  "Floor Plan": "Pohjapiirros",
  Locations: "Sijainnit",
  Categories: "Kategoriat",
  "Search resource name...": "Etsi resurssin nimi...",
  Calendar: "Kalenteri",
  "View Details": "Näytä tiedot",
  "Add to My Favorites": "Lisää suosikkeihini",
  Remove: "Poista",
  "Resource calendar": "Resurssikalenteri",
  Today: "Tänään",
  "Previous month": "Edellinen kuukausi",
  "Next month": "Seuraava kuukausi",
  "Previous year": "Edellinen vuosi",
  "Next year": "Seuraava vuosi",
  Close: "Sulje",
  "Field is required.": "Kenttä on pakollinen.",
  "Invalid date format.": "Virheellinen päivämäärämuoto.",
  S: "Su",
  M: "Ma",
  T: "Ti",
  W: "Ke",
  F: "Pe",
  January: "Tammikuu",
  February: "Helmikuu",
  March: "Maaliskuu",
  April: "Huhtikuu",
  May: "Toukokuu",
  June: "Kesäkuu",
  July: "Heinäkuu",
  August: "Elokuu",
  September: "Syyskuu",
  October: "Lokakuu",
  November: "Marraskuu",
  December: "Joulukuu",
  Jan: "Tammi",
  Feb: "Helmi",
  Mar: "Maalis",
  Apr: "Huhti",
  Jun: "Kesä",
  Jul: "Heinä",
  Aug: "Elo",
  Sep: "Syys",
  Oct: "Loka",
  Nov: "Marras",
  Dec: "Joulu",
  st: ".",
  nd: ".",
  rd: ".",
  th: ".",
  Sunday: "Sunnuntai",
  Monday: "Maanantai",
  Tuesday: "Tiistai",
  Wednesday: "Keskiviikko",
  Thursday: "Torstai",
  Friday: "Perjantai",
  Saturday: "Lauantai",
  Sun: "Su",
  Mon: "Ma",
  Tue: "Ti",
  Wed: "Ke",
  Thu: "To",
  Fri: "Pe",
  Sat: "La",
  Su: "Su",
  Mo: "Ma",
  Tu: "Ti",
  We: "Ke",
  Th: "To",
  Fr: "Pe",
  Sa: "La",
  PM: "IP",
  AM: "AP",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Et voi varata tätä resurssia, koska kokouspyyntösi on ristiriidassa resurssin varauskäytäntöjen kanssa.",
  "You need permissions to interact with this resource.":
    "Tarvitset oikeudet toimia tämän resurssin kanssa.",
  Reason: "Syy",
  "The resource cannot be booked {{day}} days in advanced.":
    "Resurssia ei voi varata {{day}} päivää etukäteen.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Toistuvan kokouksen päättymispäivämäärä ei voi olla yli {{day}} päivää tänään.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Kokouksen kesto ei voi olla yli {{time}} minuuttia.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Kokouksen kesto ei voi olla alle {{time}} minuuttia.",
  "Booking policy": "Varauskäytäntö",
  Available: "Saatavilla",
  Selected: "Valittu",
  Booked: "Varattu",
  Closed: "Suljettu",
  "Filter Options": "Suodatusvaihtoehdot",
  "{{resource}} is deleted": "{{resource}} on poistettu.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Tätä resurssia voidaan varata, mutta mitään konflikteja sisältäviä tapahtumia ei varata.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Tätä resurssia voidaan varata enintään {{day}} päivää etukäteen, mitään tätä aikarajaa ylittäviä tapahtumia ei varata",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Tätä resurssia voidaan varata, mutta kokouksen keston on oltava vähintään {{time}} minuuttia.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Tätä resurssia voidaan varata, mutta kokouksen kesto ei saa ylittää {{time}} minuuttia.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Tämän resurssin varaaminen edellyttää hyväksyntää resurssin edustajalta. Pyyntösi välitetään eteenpäin odottamaan hyväksyntää.",
  "Resource Name": "Resurssin nimi",
  Description: "Kuvaus",
  "Resource Mail": "Resurssin sähköposti",
  Location: "Sijainti",
  Capacity: "Kapasiteetti",
  Language: "Kieli",
  "Select an language": "Valitse kieli",
  "Date/Time Format": "Päivä/aika muoto",
  "First day of the week": "Viikon ensimmäinen päivä",
  "Please select a first day": "Valitse ensimmäinen päivä",
  "Please select a time format": "Valitse aikamuoto",
  "Date Format": "Päiväysmuoto",
  "Please select a date format": "Valitse päiväysmuoto",
  "Date Separator": "Päivämäärän erotin",
  "Please select a date separator": "Valitse päivämäärän erotin",
  Apply: "Hyväksy",
  "Default Location": "Oletussijainti",
  Clear: "Tyhjennä",
  Help: "Ohje",
  "Unavailable": "Ei käytettävissä",
      "No data available": "Ei saatavilla olevia tietoja",
      "More": "Lisää",
  "Available Floor Plans": "Saatavilla olevat pohjapiirrokset",
  "Default Categories": "Oletuskategoriat",
  "List more Resources": "Listaa lisää resursseja",
  Attendees: "Osallistujat",
  "Click on Further information to visit our support site":
    "Napsauta Lisätietoja vieraillaksesi tukisivustollamme",
    "New Order": "Uusi tilaus",
  "Save default categories successfully": "Tallenna oletuskategoriat onnistuneesti",
      "Save config date/time successfully": "Tallenna asetuspäivä/aika onnistuneesti",
      "Save language successfully": "Tallenna kieli onnistuneesti",
      "Save default location successfully": "Tallenna oletussijainti onnistuneesti",
      "And": "Ja",
  "Or": "Tai",
  "Available occurrences of the series": "Sarjan saatavilla olevat tapahtumat",
  "Conflicting Occurrences": "Ristiriitaiset tapahtumat",
  "Availability": "Saatavuus",
  "Time Format": "Aikamuoto",
  "You do not have permission to book this resource.": "Sinulla ei ole lupaa varata tätä resurssia.",
"This resource does not allow booking of recurring meetings.": "Tämä resurssi ei salli toistuvien kokousten varaamista.",
"You cannot book this resource.": "Et voi varata tätä resurssia."
};
